import { useEffect, createContext, useRef, useState } from "react";
import "font-awesome/css/font-awesome.min.css";
import LoadScripts from "./LoadScripts";
import Layout from "./Components/Layout";
import { Link } from "react-router-dom";
import SocialIcons from "./Components/SocialIcons";
import Publisher from "./Components/Publisher";
import Card from "./Card"; // Import the Card component

export const LanguageContext = createContext();

function App() {
  const [language, setLanguage] = useState("en");
  <LoadScripts />;
  return (
    <>
      <LanguageContext.Provider value={{ language, setLanguage }}>
        {/* Load Scripts and Layout */}
        <LoadScripts />
        <Layout />

        {/* Banner Section ======================*/}
        <section className="blog-content-section py-50 py-lg-80 py-xxl-100">
          <div className="container">
            <div className="row align-items-start position-relative">
              <div className="social-share-icons d-flex align-items-center gap-30"></div>
              <div className="">
                {/* Banner Image */}
                <div className="blog-content-image mt-50 mb-40 mt-lg-100 mb-lg-60 mx-lg-n100 position-relative overflow-hidden">
                  <picture>
                    <source
                      media="(max-width:575px)"
                      srcSet="https://res.cloudinary.com/drevcfxu5/image/upload/v1737281125/image_ixjhit.jpg"
                    />
                    <img
                      src="https://res.cloudinary.com/drevcfxu5/image/upload/v1737281125/image_ixjhit.jpg"
                      className="img-fluid"
                      alt="img"
                    />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Banner Section End ======================*/}

        {/* Blog-content Section ======================*/}
        <section className="blog-section blog-vertical pb-50 pb-lg-80">
          <div className="container">
            <div className="row gy-4 gy-lg-0 align-items-lg-end justify-content-lg-between mb-30 mb-lg-70">
              <div className="col-lg-4"></div>
            </div>
            {/* Card Grid */}
            <div className="row">
              {/* Example cards, replace with your data */}
              <div className="col-lg-3 col-md-6 mb-4">
                <Card
                  image="assets/images/home-2/blog-image-1.jpg"
                  date="Booth No :A31"
                  title="Publisher Name :"
                  description="Lorem ipsum"
                  // link="blog-single-1.html"
                />
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <Card
                  image="assets/images/home-2/blog-image-2.jpg"
                  date="Booth No :A31"
                  title="Publisher Name:"
 description="Lorem ipsum"
                  // link="blog-single-1.html"
                />
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <Card
                  image="assets/images/home-2/blog-image-3.jpg"
                  // image="assets/images/home-2/blog-image-2.jpg"
                  date="Booth No :A31"
                  title="Publisher Name:"
                   description="Lorem ipsum"
                  // link="blog-single-1.html"
                />
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <Card
                  image="assets/images/home-2/blog-image-2.jpg"
                  date="Booth No :A31"
                  title="Publisher Name:"
                   description="Lorem ipsum"
                />
              </div>
              {/* Add more cards as needed */}
            </div>
          </div>
        </section>
        {/* Blog-content Section End ======================*/}

        {/* Subscription Section ======================*/}
        <section className="subscription-section subscription-2 position-relative py-50 py-lg-70 py-xxl-100">
          <div className="container">
            <div className="subscription-wrapper">
              <div className="row justify-content-between gy-40 gy-lg-0">
                <div className="col-lg-5">
                  <div className="subscription-left-content">
                    <div className="section-title mb-4 mb-lg-5">
                      <span className="fs-3 straight-line-wrapper fw-semibold position-relative">
                        <span className="straight-line" />
                        Come Join Us
                      </span>
                      <h2 className="title display-3 fw-extra-bold d-flex flex-column">
                        <span className="sub-title fw-extra-bold text-primary">
                          Locate Us
                        </span>
                      </h2>
                    </div>
                    <p className="custom-jakarta custom-font-style-2 fs-head-2">
                      Azad Maidan Fort
                    </p>
                    <p className="custom-jakarta custom-font-style-2 fs-head-3 mb-30">
                      Mumbai, Maharashtra.
                    </p>
                    <p className="custom-jakarta custom-font-style-2 fs-head-3">
                      Customer Care: 1800-NBT-1800
                    </p>
                    <SocialIcons />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h3 className="straight-line-wrapper fw-semibold position-relative mb-20">
                    <span className="straight-line" />
                  </h3>
                  <div className="map-image parallax position-relative">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7066.143530967342!2d72.82690714060489!3d18.937973027078225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1de97217edb%3A0x252e1ef8cba95a82!2sAzad%20Maidan%2C%20Fort%2C%20Mumbai%2C%20Maharashtra!5e1!3m2!1sen!2sin!4v1734977102940!5m2!1sen!2sin"
                      width="100%"
                      height="380px"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Subscription Section ======================*/}

        {/* Footer ======================*/}
        <footer className="footer-section footer-1 py-lg-50 py-40 mt-auto">
          <div className="container">
            <div className="row gy-lg-0 gy-10 justify-content-between align-items-center text-center text-lg-start">
              <div className="col-lg-4 order-3 order-lg-1">
                <p className="custom-jakarta custom-font-style-2 footer-nav">
                  © 2025{" "}
                  <a
                    href="https://themeperch.net/"
                    className="text-decoration-none"
                    target="_blank"
                  >
                    5th Dimension Technologies
                  </a>
                </p>
              </div>
              <div className="col-lg-4 order-1 order-lg-2">
                <a
                  className="navbar-brand d-flex justify-content-center"
                  hre="/"
                  aria-label="nav-brands"
                >
                  <img
                    src="assets/images/logoo.png"
                    className="logo-light"
                    alt="logo"
                  />
                  <img
                    src="assets/images/logoo.png"
                    className="logo-dark"
                    alt="logo"
                  />
                </a>
              </div>
            </div>
          </div>
        </footer>
        {/* Footer ======================*/}
      </LanguageContext.Provider>
    </>
  );
}

export default App;
